import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../utils";

export type MarketIconSize = "xs" | "sm" | "md" | "lg" | "xl";
export type MarketIconSymbol = "btc" | "eth" | "arb" | "usdc";

export interface MarketIconProps extends HTMLAttributes<HTMLImageElement> {
  ref?: Ref<HTMLImageElement>;
  size?: MarketIconSize;
  symbol: MarketIconSymbol;
}

const marketSrcMap: Record<MarketIconSymbol, string> = {
  arb: new URL("../assets/tokens/arb.png", import.meta.url).href,
  btc: new URL("../assets/tokens/btc.png", import.meta.url).href,
  eth: new URL("../assets/tokens/eth.png", import.meta.url).href,
  usdc: new URL("../assets/tokens/usdc.png", import.meta.url).href,
};

export const MarketIcon = ({
  size = "md",
  symbol,
  className,
  onClick,
  ref,
  ...props
}: MarketIconProps) => {
  const src = marketSrcMap[symbol];

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- The img element is used here for displaying the market icon and needs to handle click events for interaction purposes.
    <img
      ref={ref}
      src={src}
      alt={symbol}
      className={cn(
        {
          "ui:cursor-pointer": Boolean(onClick),
        },
        {
          "ui:size-3": size === "xs",
          "ui:size-4": size === "sm",
          "ui:size-5": size === "md",
          "ui:size-6": size === "lg",
          "ui:size-7": size === "xl",
        },
        className,
      )}
      onClick={onClick}
      {...props}
    />
  );
};
